import { apiRequest } from "./client";

export type SupportTicketPayload = {
	/** Anonymous submissions only — authenticated requests are rejected if these are present,
	 * since the backend takes both from the account behind the token. */
	name?: string;
	email?: string;
	subject: string;
	message: string;
	/** Honeypot — the field is hidden on the form, so only a bot ever fills it. The backend silently
	 * discards any submission that carries a value here. */
	website?: string;
};

/** Files a support complaint/query. Pass the access token when signed in so the backend links the
 * ticket to the account; anonymous submissions are accepted without one. */
export const submitSupportTicket = (payload: SupportTicketPayload, token?: string | null): Promise<void> =>
	apiRequest<void>("/support/tickets", { method: "POST", body: payload, token });
